import { render, staticRenderFns } from "./informed-consent.vue?vue&type=template&id=6caf24e1&scoped=true&"
import script from "./informed-consent.vue?vue&type=script&lang=js&"
export * from "./informed-consent.vue?vue&type=script&lang=js&"
import style0 from "./informed-consent.vue?vue&type=style&index=0&id=6caf24e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf24e1",
  null
  
)

export default component.exports